import { Box } from '@mui/system';
import { makeStyles } from '@mui/styles';
import { Typography, Button } from '@mui/material';
// Assets
import { ReactComponent as CardDouble } from 'assets/modalKYX/Card_double.svg';

const useStyles = makeStyles({
    banner: {
        backgroundColor: '#182D55 !important',
        maxWidth: '16em',
        minHeight: '100%',
        paddingTop: '3em',
        borderTopLeftRadius: '10px',
        borderBottomLeftRadius: '10px'
    },
    dialogBody: {
        display: 'flex',
        flexDirection: 'row',
        minHeight: '600px',
        height: '100%'
    },
    bannerTitle: {
        color: 'white',
        fontWeight: '700!important'
    },
    bannerSpan: {
        color: 'white'
    },
    bannerText: {
        margin: '1em'
    },
    dialogContent: {
        backgroundColor: 'transparent!important',
        padding: '0!important',
        minHeight: '600px',
        minWidth: '64em'
    },
    content: {
        margin: '2em',
        width: '40em'
    },
    contentTitle: {
        fontWeight: '700!important'
    },
    verifyOption: {
        borderRadius: '15px',
        border: '1px solid #d4d4d4',
        padding: '2em 1em',
        display: 'flex',
        flexDirection: 'row',
        paddingRight: '36px',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    verifyText: {
        maxWidth: '30em'
    },
    verifyTitle: {
        fontWeight: '700!important'
    },
    startKYX: {
        color: 'white!important',
        borderRadius: '25px!important',
        marginLeft: '1em',
        padding: '.5em 1em!important'
    },
    doItLater: {
        marginTop: '10em'
    },
    anchorHere: {
        color: '#1BAAE2',
        textDecoration: 'none'
    }
});

export const KYXEulaThirdStep = ({ handleKYClose }) => {
    const classes = useStyles();

    const handleAccept = async () => {
        handleKYClose();
    };

    return (
        <Box className={classes.dialogBody}>
            <Box
                className={classes.banner}
                sx={{
                    display: { lg: 'initial', md: 'initial', sm: 'none', xs: 'none' }
                }}>
                <CardDouble />
                <Box className={classes.bannerText}>
                    <Typography variant="h5" component="h5" className={classes.bannerTitle}>
                        Welcome to the Paystand DeFi Corporate Card!
                    </Typography>
                    <Typography className={classes.bannerSpan}>
                        Manage all of your expenses with virtual cards that work exactly like credit cards, and give you reward
                        points in bitcoin.
                    </Typography>
                </Box>
            </Box>
            <Box className={classes.content}>
                <Typography variant="h6" className={classes.contentTitle}>
                    USA Patriot Act
                </Typography>
                <Box>
                    <Box
                        style={{
                            overflowY: 'scroll',
                            maxHeight: '400px',
                            marginTop: '20px',
                            marginBottom: '15px',
                            fontSize: '13px',
                            padding: '15px',
                            fontWeight: '500',
                            color: '#182D55',
                            border: '1px solid #DFE3E6',
                            borderRadius: '5px'
                        }}>
                        <p>
                            To help the U.S. government fight the funding of terrorism and money laundering activities, Federal
                            law requires all U.S. financial institutions to obtain, verify, and record information that identifies
                            each individual or legal entity that opens an account or establishes a customer relationship with
                            Paystand, Inc (“Paystand”). Federal law also requires all U.S. financial institutions to obtain,
                            verify, and record information that identifies the beneficial owners of a legal entity that opens an
                            account or establishes a consumer relationship with Paystand.
                        </p>
                        <br />
                        <p>
                            What this means for you: If you enter into a new customer relationship with Paystand, we will ask for
                            the following:
                        </p>

                        <ul>
                            <li>
                                Name, address, date of birth, taxpayer identification number and other identification information
                                that will allow us to identify all customers on the account. We may also ask to see a driver’s
                                license, passport, or other identifying documents.
                            </li>
                        </ul>
                        <br />
                        <p>
                            In addition, if you enter into a new relationship with Paystand on behalf of a legal entity, we will
                            ask for the following:
                        </p>

                        <ul>
                            <li>
                                Names, addresses, dates of birth and other identification information of the beneficial owners of
                                the legal entity.
                            </li>
                            <li>
                                Entity name, address, taxpayer identification number, affiliations and ownership. We may ask to
                                see the certified business documents or other identifying documents on the entity.
                            </li>
                        </ul>
                        <br />
                        <p>
                            This information will be used to verify your identity and, in the case of a legal entity customer, the
                            identity of the beneficial owners. As appropriate, Paystand may, in its discretion, ask for additional
                            documentation or information. If all required documentation or information is not provided or we are
                            unable to verify the information provided, Paystand may be unable to open an account or establish a
                            relationship with you.
                        </p>

                        <p>
                            We sincerely thank you for your patience and cooperation. If you have any questions regarding these
                            requirements, please contact us at <u>1-800-708-6413</u>.
                        </p>
                    </Box>
                    <Box sx={{ mt: '20px', display: 'flex', justifyContent: 'flex-end' }}>
                        <Button variant="contained" color="primary" onClick={handleAccept} sx={{ marginTop: '30px' }}>
                            Next
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};
